import styles from './QuotaProgress.module.scss';

interface QuotaProgressProps {
  label: string;
  used: number;
  total: number;
  tone?: 'individual' | 'group';
}

export function QuotaProgress({ label, used, total, tone = 'individual' }: QuotaProgressProps) {
  const remaining = Math.max(0, total - used);
  const pct = total > 0 ? Math.min(100, (used / total) * 100) : 0;
  return (
    <div className={`${styles.wrap} ${styles[`tone-${tone}`]}`}>
      <div className={styles.header}>
        <span className={styles.label}>{label}</span>
        <span className={styles.count}>
          <strong>{remaining}</strong> de {total} disponibles
        </span>
      </div>
      <div className={styles.bar} role="progressbar" aria-valuemin={0} aria-valuemax={total} aria-valuenow={used} aria-label={label}>
        <span className={styles.fill} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
